import { createSelector } from '@reduxjs/toolkit';
import { initialState } from './types/initialState';
import { RootState } from 'newTypes';

const selectDomain = (state: RootState) => {
  if (state && state.servicesState) {
    return state.servicesState;
  } else {
    return initialState;
  }
};

export const selectLoading = createSelector([selectDomain], (state) => state.loading);
export const selectButtonLoading = createSelector([selectDomain], (state) => state.buttonLoading);
export const selectList = createSelector([selectDomain], (state) => state.List);
export const selectForm = createSelector([selectDomain], (state) => state.form);
export const selectIsFileUpload = createSelector([selectDomain], (state) => state.isFileUpload);
